// extracted by mini-css-extract-plugin
export default {"Container":"Skeleton_Container__kuJNx","left":"Skeleton_left__53vb1","right":"Skeleton_right__y67kY"};